import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
// import { BrowserRouter } from 'react-router-dom';
import App from "./App";
import UserContext from "./Context/UserContextAPI";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

const localStoragePersister = createSyncStoragePersister({
  storage: localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      return query.meta?.persist === true;
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <QueryClientProvider client={queryClient}>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 3500,
          style: {
            background: "#363636",
            color: "#fff",
            minWidth: "200px", // Increase the minimum width
          },
        }}
      />
      <UserContext>
        <App />
      </UserContext>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </>
);
